<section class="content-ficha-tecnica">
    <div class="content-close">
        <button mat-icon-button [mat-dialog-close]="true">
          <mat-icon>close</mat-icon>
        </button>
    </div>
    <h1 class="title">{{specs.title}}</h1>
    <h2 class="subtitle">{{specs.subtitle}}</h2>
    <div class="content-specs">
        <div class="firts-specs">
            <div class="content-img">
                <img class="img-car-specs" *ngIf="specs.imgCar" [src]="specs.imgCar" alt="car image">
            </div>
            <div class="content-first-specs scroll-gray">
                <ng-container *ngFor="let firstSpecs of specs.fisrtColumnSpecs">
                    <app-table-specs [data]="firstSpecs"></app-table-specs>
                </ng-container>
            </div>
        </div>
        <div class="second-specs scroll-gray">
            <ng-container *ngFor="let secondSpecs of specs.secondColumnSpecs">
                <app-table-specs [data]="secondSpecs"></app-table-specs>
            </ng-container>
        </div>
    </div>
    <div class="content-specs-all">
        <div class="content-img">
            <img class="img-car-specs" *ngIf="specs.imgCar" [src]="specs.imgCar" alt="car image">
        </div>
        <div class="all-specs scroll-gray">
            <ng-container *ngFor="let secondSpecs of specs.allSpecs">
                <app-table-specs [data]="secondSpecs"></app-table-specs>
            </ng-container>
        </div>
    </div>
</section>
